import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { formatDateTime } from "@/common/dateUtils";

interface SnapshotsProps {
  snapshots: any[]; // eslint-disable-line @typescript-eslint/no-explicit-any
  returnToCurrent: () => void;
  loadSnapshot: (snapshotId: string) => void;
  activeSnapshotId: string | null;
  snapshotView?: boolean;
}

export const Snapshots: React.FC<SnapshotsProps> = ({
  snapshots,
  returnToCurrent,
  loadSnapshot,
  activeSnapshotId,
  snapshotView = false,
}) => {
  const [snapshotsCollapsed, setSnapshotsCollapsed] = useState(true);

  return (
    <div className="px-4 py-2 border-t border-gray-200">
      <div className="flex justify-between items-center mb-2">
        <div className="text-sm text-gray-500">Snapshots</div>
        <button
          onClick={() => setSnapshotsCollapsed((prev) => !prev)}
          className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
        >
          {snapshotsCollapsed ? (
            <ChevronUp className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )}
        </button>
      </div>
      {!snapshotsCollapsed && (
        <div className="flex flex-wrap gap-2">
          <div
            onClick={returnToCurrent}
            className={`text-xs rounded px-2 py-1 flex items-center gap-2 cursor-pointer
                      ${
                        !snapshotView
                          ? "bg-blue-100 text-blue-800"
                          : "bg-gray-100 hover:bg-gray-200"
                      }`}
          >
            <span>Current</span>
          </div>
          {snapshots.map((snapshot) => (
            <div
              key={snapshot.id}
              onClick={() => loadSnapshot(snapshot.id)}
              className={`text-xs rounded px-2 py-1 flex items-center gap-2 cursor-pointer
                        ${
                          activeSnapshotId === snapshot.id
                            ? "bg-blue-100 text-blue-800"
                            : "bg-gray-100 hover:bg-gray-200"
                        }`}
            >
              <span>{formatDateTime(new Date(snapshot.created_at))}</span>
              {snapshot.title && (
                <span className="text-gray-600">- {snapshot.title}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
